// oxlint-disable-next-line no-restricted-imports
import { fromJS, Map, Record, Set } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput, ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import type { ResourceApprovalSettingsProps } from '#utils/environments/types';
import { ApprovalRequirementStrategy, ApprovalResourceKind, ApprovalServiceKind } from '#utils/environments/types';

export class ResourceApprovalSettings extends Record<ResourceApprovalSettingsProps>({
  serviceKind: ApprovalServiceKind.LaunchDarklyApprovalServiceKind,
  serviceKindConfigurationId: undefined,
  serviceConfig: Map(),
  required: false,
  canReviewOwnRequest: false,
  bypassApprovalsForPendingChanges: false,
  minNumApprovals: 1,
  canApplyDeclinedChanges: true,
  requiredApprovalTags: Set<string>(),
  approvalRequirementStrategy: ApprovalRequirementStrategy.NONE,
  autoApplyApprovedChanges: undefined,
  resourceKind: ApprovalResourceKind.FLAG,
}) {
  getApprovalRequirementStrategy(): ApprovalRequirementStrategy {
    if (this.required) {
      return ApprovalRequirementStrategy.ALL;
    } else if (this.requiredApprovalTags.size > 0) {
      return ApprovalRequirementStrategy.BY_TAG;
    }

    return ApprovalRequirementStrategy.NONE;
  }
  toRep(): ResourceApprovalSettings {
    return fromJS(this.toJSON()).withMutations((map: ImmutableMap<ResourceApprovalSettingsProps>) => {
      if (map.get('approvalRequirementStrategy') !== ApprovalRequirementStrategy.BY_TAG) {
        map.set('requiredApprovalTags', Set<string>());
      }
      map.remove('approvalRequirementStrategy');
    });
  }
}

export function createResourceApprovalRequestSettings(props: CreateFunctionInput<ResourceApprovalSettings> = {}) {
  const approvalSettings =
    props instanceof ResourceApprovalSettings ? props : new ResourceApprovalSettings(fromJS(props));

  return approvalSettings.withMutations((a) => {
    a.update('requiredApprovalTags', (requiredApprovalTags) =>
      requiredApprovalTags ? requiredApprovalTags.toSet() : Set<string>(),
    );
    a.update('approvalRequirementStrategy', (strategy) =>
      !Object.values(ApprovalRequirementStrategy).includes(strategy) || strategy === ApprovalRequirementStrategy.NONE
        ? a.getApprovalRequirementStrategy()
        : strategy,
    );
  });
}
